/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_content_delivery_bucket": "neoreports-20200207150154-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d1wz11q36o2x5f.cloudfront.net",
    "aws_cognito_identity_pool_id": "us-east-1:17da293f-34cf-4449-910e-915452488326",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_fGG7tcvm1",
    "aws_user_pools_web_client_id": "7rth90046lk38u8el4nakiqdbb",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://4xikcjoyufhf3ilfblyovjhlzy.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-6pdffbi4rvcqrbomt32x36n43u",
    "aws_cloud_logic_custom": [
        {
            "name": "lambdasApi",
            "endpoint": "https://ld377oj1hh.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "spreadsheets145653-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
